// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addWeeks as fn } from "../addWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addWeeksWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addWeeksWithOptions;
